import * as z from "zod/v4";

export const saveAccountMappings = {
  name: "saveAccountMappings" as const,
  input: z.object({
    mappings: z.array(
      z.object({
        mappingType: z.string(),
        externalAccountId: z.string(),
        accountName: z.string(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
